import cuid from 'cuid';
import { EditorActions } from 'app/stores/editor/actions';
import { hasClipboard } from 'app/utils/caniuse';
import { Capabilities } from 'app/utils/Capabilities';
import { errorNotifier } from 'app/utils/error';
class MissingApiError extends Error {
    constructor() {
        super('Missing API');
    }
}
class ClipboardRenders {
    constructor() {
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
    }
    clear() {
        this.data.clear();
    }
    set(blob) {
        const id = cuid();
        this.data.clear();
        this.data.set(id, blob);
        setTimeout(() => this.data.clear(), 5 * 60 * 1000); // auto remove after 5 mintues
        return id;
    }
    has(data) {
        const values = new Set(this.data.values());
        return values.has(data);
    }
    get(id) {
        return this.data.get(id);
    }
}
export const clipboardRenders = new ClipboardRenders();
export const prepareOnWriteToClipboard = (output, dispatch) => {
    if (Capabilities.shared.isSafari) {
        // on Safari present popup with dialog
        dispatch(EditorActions.setClipboardRender(clipboardRenders.set(output)));
        return Promise.resolve(true);
    }
    return saveToClipboardWithToasts(output, dispatch);
};
export const saveToClipboardWithToasts = (output, dispatch) => saveToClipboard(output)
    .then(() => dispatch(EditorActions.showToast({
    message: 'Image has beed added to your clipboard',
    variant: 'positive',
})))
    .catch(() => dispatch(EditorActions.showToast({
    message: 'Failed to copy image to clipboard. Try downloading instead.',
    variant: 'negative',
})))
    .then(() => true);
export const saveToClipboard = (output) => {
    if (!hasClipboard()) {
        return Promise.reject(new MissingApiError());
    }
    const [render] = output !== null && output !== void 0 ? output : [];
    const dataMimeType = render.data.type;
    let item;
    if (Capabilities.shared.isSafari) {
        // see https://web.dev/async-clipboard/ and https://developer.apple.com/forums/thread/691873
        item = new ClipboardItem({
            [dataMimeType]: new Promise(resolve => {
                resolve(render.data);
            }),
        });
    }
    else {
        item = new ClipboardItem({ [dataMimeType]: render.data });
    }
    const data = [item];
    return new Promise((resolve, reject) => {
        const { clipboard } = navigator;
        if (clipboard) {
            try {
                clipboard
                    .write(data)
                    .then((result) => {
                    resolve(result);
                })
                    .catch((err) => {
                    reject(err);
                });
            }
            catch (err) {
                errorNotifier(err);
            }
        }
    });
};
